// UserContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchAccountCompetitors, fetchAccountDetails, fetchAccountInfo, fetchClientProductOpportunities } from '../services/accIqService';
import api from '../services/api'
import { useUser } from './UserContext';

// const AccountContext = createContext(null);
const AccountContext = createContext({ account_info: [], account_details: [] });

export const AccountContextProvider = ({ children }) => {
  const { user } = useUser();
  const [account_info, setAccountInfo] = useState(null);
  const [account_details, setAccountDetails] = useState(null);

  const { accountId, accountName, clientName } = useParams();

  useEffect(() => {
    if (!accountId || !accountName || !clientName || !user) {
      return; // Avoid running the effect if these values are not ready
    }
    const getAccountInfo = async () => {
      try {
        const account_info = await fetchAccountInfo(accountId, accountName);
        //const account_info = await fetchAccountInfo(accountId);

          const response = await api.get('/accounts/get_accounts', {
            params: {          
              page: 1,
              limit: 1,
              sort_by: 'created_date',
              order: 'asc',
              id : accountId
            },
          });
        account_info.db_details =  response?.data?.result?.list?.[0] || {};


        const sortedData = account_info?.business_units?.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
        
            // Check if name is "other" or "others" and keep it at the end
            const isOtherA = nameA === "other" || nameA === "others";
            const isOtherB = nameB === "other" || nameB === "others";
            
            if (isOtherA && !isOtherB) return 1;
            if (isOtherB && !isOtherA) return -1;
        
            // Sort by revenue in descending order
            return b.revenue - a.revenue;
        });
      
        account_info.business_units = sortedData;


        setAccountInfo(account_info);
      } catch (error) {
        console.error('Error fetching Account Info:', error);
      }
    };
    getAccountInfo();

    const getAccountDetails = async () => {
      try {
        const account_details = await fetchAccountDetails(accountId, accountName, clientName);

        let competitorsResult = await fetchAccountCompetitors(accountId, accountName, clientName);
        account_details.competitors = competitorsResult?.competitors || [];

        const client_product_opportunities = await fetchClientProductOpportunities(accountId, accountName, clientName);
        account_details.client_product_opportunities = client_product_opportunities || [];

        // Set Order
        const bu_order = account_info?.business_units?.reduce((acc, bu, index) => {
            acc[bu.name.trim()] = index;
            return acc;
        }, {});
    
        if(bu_order){
          account_details?.key_products_services?.sort((a, b) => {
              return bu_order[a.bu_name.trim()] - bu_order[b.bu_name.trim()];
          });
        }
        // End: Set Order

        setAccountDetails(account_details);
      } catch (error) {
        console.error('Error fetching Account Details:', error);
      }
    };
    getAccountDetails();

  }, [accountId, accountName, clientName]);

  return (
    <AccountContext.Provider value={{account_info, account_details}}>
      {children}
    </AccountContext.Provider>
  );
};


export const useAccount = () => useContext(AccountContext);
